import { t } from 'ember-intl';
import QuestionsGlossary from 'tio-employee/components/questions/glossary';
import { Section, VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';

<template>
  <VStack>
    <PageHeader @title={{t "sidebar.loan_glossary"}} @sticky={{false}} />
    <Section>
      <:header>{{t "questions_you_have.glossary.glossary_subtitle"}}</:header>
      <:body>
        <VStack>
          <QuestionsGlossary />
        </VStack>
      </:body>
    </Section>
  </VStack>
</template>
